// EditAdmin.js
import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";

const EditAdmin = ({ open, onClose, admin, onSave }) => {
  const [adminData, setAdminData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_no: "",
  });

  const [errors, setErrors] = useState({});

  // ✅ Validation regex
  const nameRegex = /^[A-Za-z]{2,20}$/;
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^(?=.{2,50}$)[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

  const phoneRegex = /^[6-9]\d{9}$/;

  useEffect(() => {
    if (open && admin) {
      setAdminData({
        first_name: admin.first_name || "",
        last_name: admin.last_name || "",
        email: admin.email || "",
        phone_no: admin.phone_no || "",
      });
      setErrors({});
    }
  }, [open, admin]);

  const handleChange = (e) => {
    let { name, value } = e.target;

    // First & Last name → only alphabets
    if (name === "first_name" || name === "last_name") {
      value = value.replace(/[^A-Za-z]/g, "");
    }

  if (name === "email") {
  value = value.replace(/^\s+/, "").replace(/\s+$/, "");
}

    // Phone → only digits, max 10
    if (name === "phone_no") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    setAdminData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Real-time validation
    let error = "";
    if ((name === "first_name" || name === "last_name") && value && !nameRegex.test(value)) {
      error = "Only alphabets (2–20), no spaces";
    }
    if (name === "email") {
  if (!value) {
    error = "";
  } else if (value.length > 50) {
    error = "Email must not exceed 50 characters";
  } else if (value.length >= 2 && !emailRegex.test(value)) {
    error = "Invalid email format";
  }
}
    if (name === "phone_no" && value && !phoneRegex.test(value)) {
      error = "Must start from 6–9 and be 10 digits";
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const validateForm = () => {
    const tempErrors = {};
    const firstName = adminData.first_name.trim();
    const lastName = adminData.last_name.trim();
    const email = adminData.email.trim();
    const phone = adminData.phone_no.trim();

    if (!firstName) tempErrors.first_name = "First name is required";
    else if (!nameRegex.test(firstName))
      tempErrors.first_name = "Only alphabets, 2–20 characters, no spaces";

    if (!lastName) tempErrors.last_name = "Last name is required";
    else if (!nameRegex.test(lastName))
      tempErrors.last_name = "Only alphabets, 2–20 characters, no spaces";

    if (!email) {
  tempErrors.email = "Email is required";
} else if (email.length < 2 || email.length > 50) {
  tempErrors.email = "Email must be 2–50 characters";
} else if (!emailRegex.test(email)) {
  tempErrors.email = "Invalid email format";
}
    if (!phone) tempErrors.phone_no = "Phone number is required";
    else if (!phoneRegex.test(phone))
      tempErrors.phone_no = "Must start from 6–9 and be 10 digits";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const adminId = admin.id;
      const response = await apiService.post(`/api/update_admin/${adminId}/`, adminData);
      toast.success(response.data?.message || "Admin updated successfully!");
      onSave({ ...admin, ...adminData });
      setTimeout(()=>{
        onClose();
      },300);
      
    } catch (error) {
      const backendMessage =
        error.response?.data?.error || error.response?.data?.message || "Failed to update admin";
      toast.error(backendMessage);
    }
  };

  const handleCancel = () => {
    setErrors({});
    onClose();
  };

  if (!open) return null;

  return (
    <>
      <div className="edit-site-modal">
        <Box
          component="form"
          className="edit-site-container edit-site-form"
          onSubmit={handleSubmit}
        >
          <Typography className="edit-site-title">Edit Admin</Typography>

          <TextField
            label="First Name"
            name="first_name"
            value={adminData.first_name}
            onChange={handleChange}
            error={!!errors.first_name}
            helperText={errors.first_name}
          />
          <TextField
            label="Last Name"
            name="last_name"
            value={adminData.last_name}
            onChange={handleChange}
            error={!!errors.last_name}
            helperText={errors.last_name}
          />
          <TextField
            label="Email"
            name="email"
            value={adminData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
          />
          <TextField
            label="Phone Number"
            name="phone_no"
            value={adminData.phone_no}
            onChange={handleChange}
            error={!!errors.phone_no}
            helperText={errors.phone_no}
          />

          <div className="edit-btn-wrapper">
            <button type="button" className="cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
            <button type="submit" className="edit-btn">
              Save Changes
            </button>
          </div>
        </Box>
      </div>

      {/* <ToastContainer position="top-right" autoClose={3000} theme="light" /> */}
    </>
  );
};

export default EditAdmin;